import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import { Component } from 'react';
import { LogEntry } from './LogEntry.js';
import { LogLevel } from './LogLevel.js';
import MediaQuery from 'react-responsive';
import { convertDateFormat } from '../DateFormatConverter.js';
import { Settings } from './Settings';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { copyTextToClipboard } from '../Providers/ClipboardProvider';
import { ExceptionParser } from '../ExceptionParser';
var exceptionParser = new ExceptionParser();
import style from './LogTable.css';
export var LogTable =
/*#__PURE__*/
function (_Component) {
  _inherits(LogTable, _Component);

  function LogTable() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, LogTable);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(LogTable)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      showLevelSettings: false,
      highlightedRequest: null,
      copyActive: null
    });

    _defineProperty(_assertThisInitialized(_this), "toggleLevelSettings", function () {
      _this.setState({
        showLevelSettings: !_this.state.showLevelSettings
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleRelativeTime", function () {
      _this.props.setRelative(!_this.props.relative);
    });

    return _this;
  }

  _createClass(LogTable, [{
    key: "highlightRequest",
    value: function highlightRequest(highlightedRequest) {
      this.setState({
        highlightedRequest: highlightedRequest
      });
    }
  }, {
    key: "formatDate",
    value: function formatDate(entry, relative) {
      var time = new Date(entry.time);

      if (relative) {
        return OC.Util.relativeModifiedDate(time);
      } else {
        return OC.Util.formatDate(time, convertDateFormat(this.props.dateFormat));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var timeClass = style.time + (this.props.relative ? ' ' + style.relative : '');
      var rows = this.props.entries.map(function (entry, i) {
        var className = style['level_' + entry.level];

        if (entry.reqId === _this2.state.highlightedRequest) {
          className += ' ' + style.highlight;
        }

        var copyEntry = function copyEntry(raw) {
          var text = raw ? JSON.stringify(entry) : "\n[".concat(entry.app, "] ").concat(LogLevel.levels[entry.level], ": ").concat(exceptionParser.format(entry.message), "\n\n") + (entry.method ? "".concat(entry.method, " ").concat(entry.url, "\n") : '') + (entry.remoteAddr ? "from ".concat(entry.remoteAddr, " ") : '') + (entry.user !== '--' ? "by ".concat(entry.user, " ") : '') + "at ".concat(entry.time, "\n");
          copyTextToClipboard(text.trim());

          _this2.setState({
            copyActive: null
          });
        };

        return React.createElement("tr", {
          className: className + (_this2.state.copyActive === entry.id ? ' ' + style.active : ''),
          key: entry.id,
          onClick: _this2.highlightRequest.bind(_this2, entry.reqId)
        }, React.createElement("td", {
          className: style.level
        }, React.createElement(LogLevel, {
          level: entry.level
        })), React.createElement("td", {
          className: style.app
        }, entry.app), React.createElement("td", {
          className: style.message
        }, React.createElement(LogEntry, {
          message: entry.message
        })), React.createElement("td", {
          className: style.copy
        }, React.createElement("button", {
          title: t('logreader', 'Copy'),
          className: "icon icon-clippy",
          onClick: function onClick() {
            _this2.setState({
              copyActive: _this2.state.copyActive === entry.id ? null : entry.id
            });
          }
        }), _this2.state.copyActive === entry.id ? React.createElement("div", {
          className: style.copyMenu + ' popovermenu bubble open menu'
        }, React.createElement("ul", null, React.createElement("li", null, React.createElement("a", {
          className: "menuitem icon icon-clippy",
          onClick: function onClick() {
            return copyEntry(true);
          }
        }, t('logreader', 'Copy raw'))), React.createElement("li", null, React.createElement("a", {
          className: "menuitem icon icon-clippy",
          onClick: function onClick() {
            return copyEntry(false);
          }
        }, t('logreader', 'Copy formatted'))))) : []), React.createElement("td", {
          className: timeClass,
          title: _this2.formatDate(entry, !_this2.props.relative)
        }, _this2.formatDate(entry, _this2.props.relative)));
      });
      var smallRows = this.props.entries.map(function (entry, i) {
        return React.createElement("div", {
          className: style['level_' + entry.level] + ' ' + style.row,
          key: i
        }, React.createElement("div", {
          className: style.level + ' ' + style.column
        }, React.createElement(LogLevel, {
          level: entry.level
        })), React.createElement("div", {
          className: style.app + ' ' + style.column
        }, entry.app), React.createElement("div", {
          className: timeClass + ' ' + style.column
        }, _this2.formatDate(entry, _this2.props.relative)), React.createElement("div", {
          className: style.message + ' ' + style.column
        }, React.createElement(LogEntry, {
          message: entry.message
        })));
      });

      if (rows.length === 0) {
        rows = React.createElement("tr", {
          className: style.empty
        }, React.createElement("td", {
          colSpan: "4"
        }, React.createElement("div", {
          className: "emptycontent"
        }, React.createElement("div", {
          className: "icon-filetype-text"
        }), React.createElement("h2", null, t('logreader', 'No server logs')), React.createElement("p", null, this.props.hidden > 0 ? t('logreader', 'One or more entries are hidden by the log level filter') : t('logreader', 'Everything is working fine')))));
      }

      var levelSettingsHeader = React.createElement("span", {
        onClick: this.toggleLevelSettings
      }, "Level", React.createElement("span", {
        className: style['log-settings-toggle'] + ' icon-more'
      }));
      var levelHeader = this.props.inlineSettings ? levelSettingsHeader : t('logreader', 'Level');
      return React.createElement("div", null, React.createElement(MediaQuery, {
        minWidth: 750
      }, React.createElement("table", {
        className: style.logs
      }, React.createElement("thead", null, React.createElement("tr", null, React.createElement("th", {
        className: style.level + ' ' + (this.state.showLevelSettings ? style.active : '')
      }, levelHeader, this.state.showLevelSettings ? React.createElement(Settings, {
        setLevel: this.props.setLevel,
        levels: this.props.levels,
        live: this.props.live,
        setLive: this.props.setLive,
        onLogFile: this.props.onLogFile
      }) : React.createElement("div", {
        className: "hidden"
      })), React.createElement("th", {
        className: style.app
      }, t('logreader', 'App')), React.createElement("th", {
        className: style.message
      }, t('logreader', 'Message')), React.createElement("th", {
        className: style.copy
      }), React.createElement("th", {
        className: timeClass,
        onClick: this.toggleRelativeTime
      }, t('logreader', 'Time')))), React.createElement(ReactCSSTransitionGroup, {
        transitionName: "highlight",
        transitionEnterTimeout: 1500,
        transitionLeaveTimeout: 1500,
        component: "tbody"
      }, rows))), React.createElement(MediaQuery, {
        maxWidth: 768
      }, React.createElement("div", {
        className: style.smallHeader
      }, levelHeader, this.state.showLevelSettings ? React.createElement(Settings, {
        setLevel: this.props.setLevel,
        levels: this.props.levels
      }) : React.createElement("div", {
        className: "hidden"
      })), React.createElement("div", {
        className: style.logs
      }, smallRows)));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return LogTable;
}(Component);
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(exceptionParser, "exceptionParser", "/srv/http/owncloud/apps/logreader/js/Components/LogTable.js");
  reactHotLoader.register(LogTable, "LogTable", "/srv/http/owncloud/apps/logreader/js/Components/LogTable.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();